export var json = {
    programs: [
        {
            id: 1,
            value: "Automotive Technician",
            name: "Automotive Technician"
        },
        {
            id: 2,
            value: "Computer Systems Technician",
            name: "Computer Systems Technician"
        },
        {
            id: 3,
            value: "Cosmetologist",
            name: "Cosmetologist"
        },
        {
            id: 4,
            value: "Dental Assistant",
            name: "Dental Assistant"
        },
        {
            id: 5,
            value: "Massage Therapy",
            name: "Massage Therapy"
        },
        {
            id: 6,
            value: "Medical Assistant",
            name: "Medical Assistant"
        },
        {
            id: 7,
            value: "Refrigeration & HVAC",
            name: "Refrigeration & HVAC"
        },
        {
            id: 8,
            value: "Nursing Assistant",
            name: "Nursing Assistant"
        },
        {
            id: 9,
            value: "Medical Billing and Coding",
            name: "Medical Billing and Coding"
        },
        {
            id: 10,
            value: "AUTOMOTIVE",
            name: "AUTOMOTIVE"
        },
        {
            id: 11,
            value: "Biomedical Equipment Technician",
            name: "Biomedical Equipment Technician"
        },
        {
            id: 12,
            value: "Business Office Admin",
            name: "Business Office Admin"
        },
        {
            id: 13,
            value: "Business Office Administration",
            name: "Business Office Administration"
        },
        {
            id: 14,
            value: "Computer Network Systems",
            name: "Computer Network Systems"
        },
        {
            id: 15,
            value: "General",
            name: "General"
        },
        {
            id: 16,
            value: "HVAC/R",
            name: "HVAC/R"
        },
        {
            id: 18,
            value: "Personal Trainer",
            name: "Personal Trainer"
        },
        {
            id: 19,
            value: "Pharmacy Technician",
            name: "Pharmacy Technician"
        },
        {
            id: 20,
            value: "Refrigeration and HVAC Technician",
            name: "Refrigeration and HVAC Technician"
        },
        {
            id: 21,
            value: "Cosmetology",
            name: "Cosmetology"
        },
        {
            id: 22,
            value: "Not Sure",
            name: "Not Sure"
        },
        {
            id: 23,
            value: "Undecided",
            name: "Undecided"
        },
        {
            id: 24,
            value: "Medical Billing and Coding Program",
            name: "Medical Billing and Coding Program"
        },
        {
            id: 25,
            value: "Electrical Technician",
            name: "Electrical Technician"
        },
        {
            id: 26,
            value: "Other",
            name: "Other"
        }
    ],
    states: [
        { name: "Alabama", abbreviation: "AL" },
        { name: "Alaska", abbreviation: "AK" },
        { name: "Arizona", abbreviation: "AZ" },
        { name: "Arkansas", abbreviation: "AR" },
        { name: "California", abbreviation: "CA" },
        { name: "Colorado", abbreviation: "CO" },
        { name: "Connecticut", abbreviation: "CT" },
        { name: "Delaware", abbreviation: "DE" },
        { name: "District of Columbia", abbreviation: "DC" },
        { name: "Florida", abbreviation: "FL" },
        { name: "Georgia", abbreviation: "GA" },
        { name: "Hawaii", abbreviation: "HI" },
        { name: "Idaho", abbreviation: "ID" },
        { name: "Illinois", abbreviation: "IL" },
        { name: "Indiana", abbreviation: "IN" },
        { name: "Iowa", abbreviation: "IA" },
        { name: "Kansas", abbreviation: "KS" },
        { name: "Kentucky", abbreviation: "KY" },
        { name: "Lousiana", abbreviation: "LA" },
        { name: "Maine", abbreviation: "ME" },
        { name: "Maryland", abbreviation: "MD" },
        { name: "Massachusetts", abbreviation: "MA" },
        { name: "Michigan", abbreviation: "MI" },
        { name: "Minnesota", abbreviation: "MN" },
        { name: "Mississippi", abbreviation: "MS" },
        { name: "Missouri", abbreviation: "MO" },
        { name: "Montana", abbreviation: "MT" },
        { name: "Nebraska", abbreviation: "NE" },
        { name: "Nevada", abbreviation: "NV" },
        { name: "New Hampshire", abbreviation: "NH" },
        { name: "New Jersey", abbreviation: "NJ" },
        { name: "New Mexico", abbreviation: "NM" },
        { name: "New York", abbreviation: "NY" },
        { name: "North Carolina", abbreviation: "NC" },
        { name: "North Dakota", abbreviation: "ND" },
        { name: "Ohio", abbreviation: "OH" },
        { name: "Oklahoma", abbreviation: "OK" },
        { name: "Oregon", abbreviation: "OR" },
        { name: "Pennsylvania", abbreviation: "PA" },
        { name: "Rhode Island", abbreviation: "RI" },
        { name: "South Carolina", abbreviation: "SC" },
        { name: "South Dakota", abbreviation: "SD" },
        { name: "Tennessee", abbreviation: "TN" },
        { name: "Texas", abbreviation: "TX" },
        { name: "Utah", abbreviation: "UT" },
        { name: "Vermont", abbreviation: "VT" },
        { name: "Virginia", abbreviation: "VA" },
        { name: "Washington", abbreviation: "WA" },
        { name: "West Virginia", abbreviation: "WV" },
        { name: "Wisconsin", abbreviation: "WI" },
        { name: "Wyoming", abbreviation: "WY" }
    ]
};
//# sourceMappingURL=data:application/json;base64,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